import React, { useEffect } from 'react';
import { Instagram } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const InstagramSection = () => {
  useEffect(() => {
    // Load Elfsight script
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup if needed
      const existingScript = document.querySelector('script[src="https://elfsightcdn.com/platform.js"]');
      if (existingScript) {
        // Don't remove as it might be used elsewhere
      }
    };
  }, []);

  return (
    <section className="py-24 bg-gradient-to-b from-blue-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-600 text-sm font-medium mb-4">
            Social Proof
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Follow Us on <span className="text-blue-600">Instagram</span>
          </h2>
          <a
            href={companyInfo.instagramLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-gray-600 hover:text-blue-600 transition-colors"
          >
            <Instagram className="w-5 h-5 mr-2" />
            @pdmedia_
          </a>
        </div>

        {/* Elfsight Instagram Feed */}
        <div className="instagram-feed-container">
          <div 
            className="elfsight-app-5fb98377-887e-48b3-b7ec-377ef07b5f01" 
            data-elfsight-app-lazy
          />
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
